import { render, staticRenderFns } from "./admin-container.vue?vue&type=template&id=2b050b4c&scoped=true&"
import script from "./admin-container.vue?vue&type=script&lang=js&"
export * from "./admin-container.vue?vue&type=script&lang=js&"
import style0 from "./admin-container.vue?vue&type=style&index=0&id=2b050b4c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b050b4c",
  null
  
)

export default component.exports